
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'


import Camp from '../pages/Catalogs/Camp/Index'
import HighwaySection from '../pages/Catalogs/HighwaySection/Index'

import Highway from '../pages/Catalogs/Highway/Index'
import Highwaycompany from '../pages/Catalogs/Highwaycompany/'

import HighwayTollbooth from '../pages/Catalogs/HighwayTollbooth'

const highwayPages = {
  path: '/',
  component: DashboardLayout,
  name: 'highwayPages',
  title: 'Carreteras',
  customIcon: 'fa fa-road',
  excludedGroups: [ 'Extranet'  ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/highwayCompany',
      name: 'Compañía Carretera',
      title: 'Compañía Carretera',
      component: Highwaycompany,
      meta: {
        ifUserCan: {
          view: 'Highway/highwaycompany',
        },
      },
    },
    {
      path: '/highway',
      name: 'Autopistas',
      title: 'Autopistas',
      component: Highway,
      meta: {
        ifUserCan: {
          view: 'Highway/highway',
        },
      },
    },
    {
      path: '/highwayTollbooth',
      name: 'Caseta Peaje',
      title: 'Caseta Peaje',
      component: HighwayTollbooth,
      meta: {
        ifUserCan: {
          view: 'Highway/tollbooth',
        },
      },
    },
    {
      path: '/autopistas/campamento',
      name: 'Campamento',
      title: 'Campamento',
      component: Camp,
      meta: {
        ifUserCan: {
          view: 'Highway/camp',
        },
      },
    },
    {
      path: '/autopistas/tramo',
      name: 'Tramos Carreteros',
      title: 'Tramos carreteros',
      component: HighwaySection,
      meta: {
        ifUserCan: {
          view: 'Highway/highwaysection',
        },
      },
    },
  ],
}

export default highwayPages



// WEBPACK FOOTER //
// ./src/router/highwayRoutes.js